import { apiRequest } from '@/api/apiClient/base';
import type {
  CheckRepoResult,
  ConnectRepoResult,
  SettingsInfo,
} from '@/api/types';

/** The server-side settings (masked token, PAT owner login, repo config). */
export function getSettings(): Promise<SettingsInfo> {
  return apiRequest<SettingsInfo>('/api/settings');
}

/**
 * Validate and persist the registrar's GitHub PAT (forge config only). The
 * server returns the token's forge login; it never creates a user or a session.
 */
export function saveToken(token: string): Promise<{ login: string }> {
  return apiRequest<{ login: string }>('/api/settings/token', {
    method: 'PUT',
    body: { token },
  });
}

/** Remove the saved PAT. */
export function removeToken(): Promise<void> {
  return apiRequest<void>('/api/settings/token', { method: 'DELETE' });
}

/**
 * Connect the registrar to a repository under the PAT owner, creating it when
 * it does not exist. The owner is derived from the PAT server-side, so only the
 * repository name is sent.
 */
export function connectRepo(repo: string): Promise<ConnectRepoResult> {
  return apiRequest<ConnectRepoResult>('/api/settings/repo/connect', {
    method: 'POST',
    body: { repo },
  });
}

/** Check whether a repository already exists under the PAT owner. */
export function checkRepo(repo: string): Promise<CheckRepoResult> {
  return apiRequest<CheckRepoResult>('/api/settings/repo/check', {
    method: 'POST',
    body: { repo },
  });
}

/** Trigger an immediate re-index of the connected repository. */
export function refreshIndex(): Promise<void> {
  return apiRequest<void>('/api/poll', { method: 'POST' });
}
